import API from '..';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class ParameterAPI extends API {
	createParameter(parameter) {
		const dataString = JSON.stringify(parameter);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	putParameter(parameter) {
		const dataString = JSON.stringify(parameter);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/actualizar`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getParameters(pagination, currentPage) {
		const paginationUrl = pagination
			? `numeroDePagina=${currentPage}&registrosPorPagina=${pagination}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta?${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getParameterDisable(idParameter, status) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/setEstatus/${idParameter}/${status}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getParameterKey(key) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta?clave=${key}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getParameterByFilters(key, value, description, status) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta?clave=${
					key === undefined ? '' : key
				}&valor=${value === undefined ? '' : value}&descripcion=${
					description === undefined ? '' : description
				}&estatus=${status === undefined ? '' : status}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getPosition(status) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/cargo/${status}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const parameterAPI = new ParameterAPI('/parametro');
